module.exports = __webpack_public_path__ + "static/media/footer-bg.c2aae576.png";